var _path, _path2, _path3, _g, _circle, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 306.1 269.8",
    height: 296.792752,
    viewBox: "0 0 306.1 269.8",
    width: 336.935452,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 20v229.8c0 11 9 20 20 20h137.3c103.8 0 148.8-58.1 148.8-135.2 0-76.7-45-134.6-148.8-134.6h-137.3c-11 0-20 9-20 20z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91.9 56.4v169.8h73.9c67.1 0 96.2-37.9 96.2-91.5 0-51.3-29.1-91.1-96.2-91.1h-61.1c-7.1 0-12.8 5.8-12.8 12.8z",
    fill: "#c06"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m157.3 251.5h-119.4c-10.6 0-19.2-8.6-19.2-19.2v-194.7c0-10.6 8.6-19.2 19.2-19.2h119.4c113.3 0 130.2 72.9 130.2 116.3 0 75.3-46.3 116.8-130.2 116.8zm-119.4-226.7c-7.1 0-12.8 5.7-12.8 12.8v194.7c0 7.1 5.7 12.8 12.8 12.8h119.4c79.8 0 123.8-39.2 123.8-110.4 0-95.6-77.6-109.9-123.8-109.9h-119.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m117.9 111.8c2.6 0 5 .4 7.3 1.2s4.2 2.1 5.9 3.7c1.6 1.7 2.9 3.8 3.9 6.2.9 2.5 1.4 5.4 1.4 8.8 0 3-.4 5.7-1.1 8.2-.8 2.5-1.9 4.7-3.4 6.5s-3.4 3.2-5.7 4.3c-2.3 1-5 1.6-8.1 1.6h-17.5v-40.6h17.3zm-.6 33.1c1.3 0 2.5-.2 3.8-.6 1.2-.4 2.3-1.1 3.2-2.1s1.7-2.2 2.3-3.8.9-3.4.9-5.7c0-2-.2-3.9-.6-5.5s-1.1-3.1-2-4.2-2.1-2.1-3.6-2.7-3.3-.9-5.5-.9h-6.4v25.6h7.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.5 111.8v7.5h-21.4v8.7h19.7v6.9h-19.7v9.9h21.9v7.5h-30.8v-40.6h30.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m203.1 111.8 15.2 40.6h-9.3l-3.1-9h-15.2l-3.2 9h-9l15.3-40.6zm.5 24.9-5.1-14.9h-.1l-5.3 14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232.8 111.8v33.1h19.8v7.5h-28.7v-40.6z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 132.1,
    r: 18.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m72.6 226.2c-15.7 0-28.3-12.7-28.3-28.3v-22.1c0-7.8 6.3-14.2 14.2-14.2 7.8 0 14.2 6.3 14.2 14.2v50.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeal);
export default __webpack_public_path__ + "static/media/ideal.c518777d5133433baeb8b06e0c0d4773.svg";
export { ForwardRef as ReactComponent };